import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { IonButton, IonIcon, IonMenu, IonHeader, IonToolbar, IonTitle, IonContent, IonList, IonItem, IonLabel, IonAvatar } from '@ionic/react';
import { chevronForward, exitOutline, person, constructOutline } from 'ionicons/icons';
import { getLoginApp, getchek, getislogued } from '../../utils/functions';
import { Capacitor } from '@capacitor/core';
import moment from 'moment';
import {
    queryAllLocations,
    createLocationTest,
    queryAllPermisions,
    queryAllConfiguration,
    createConfiguration,
    getConfigurationById,
    updateConfigurationById,
    createActivitie
} from "../../data_base_local/dataservice";
interface IProps {

}
interface IState {
    datalogin: any;
}
class MenuPrincipal extends React.Component<IProps, IState> {
    constructor(props: any) {
        super(props)
        this.state = {
            datalogin: props.datalogin
        };
    }

    componentDidMount() {
        this.setState({
            datalogin: getLoginApp()
        });

    }

    UNSAFE_componentWillReceiveProps(nextProps: any) {

    }

    async logout() {
        if (Capacitor.isNativePlatform()) {
            let config = await getConfigurationById(1).then();
            if (config && config.values.length > 0) {
                let id_config = config.values[0].id;

                await updateConfigurationById(id_config, {
                    token: null,
                    data_login: null
                }).then();
            }

            if (this.state.datalogin) {
                //insertar deslogueo
                await createActivitie({
                    log_name: moment().format('YYYY-MM-DD HH:mm:ss'),
                    description: 'logout',
                    date: moment().format('YYYY-MM-DD HH:mm:ss'),
                    user_id: this.state.datalogin.id,
                }).then();
            }

        }

        if (getchek()) {
            //localStorage.removeItem('getLoginApp');
            localStorage.removeItem('islogued');
            window.location.reload();
        } else {
            localStorage.removeItem('getLoginApp');
            localStorage.removeItem('islogued');
            window.location.reload();
        }
    }
    render() {
        const { datalogin } = this.state;
        return (
            <>
                <IonMenu contentId="main-content">
                    <IonHeader>
                        <IonToolbar>
                            <IonButton slot="end" fill="clear" onClick={() => this.logout()}>
                                <IonIcon icon={exitOutline} color="primary" />
                            </IonButton>
                            <IonTitle className="ion-text-center"><strong>MENU</strong></IonTitle>
                        </IonToolbar>
                    </IonHeader>
                    <IonContent>
                        <IonList>
                            <IonItem color="primary" style={{ padding: '10px', '--border-radius': '10px' }}>
                                <IonAvatar slot="start"
                                    style={{
                                        '--border-radius': '50%',
                                        border: '1px solid #aaa',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center'
                                    }}>
                                    <IonIcon
                                        color="light"
                                        icon={person}
                                        size="small"
                                    />
                                </IonAvatar>
                                <IonLabel>
                                    <h2><strong>{(datalogin && datalogin.first_name) ?? ''} {(datalogin && datalogin.last_name) ?? ''}</strong></h2>
                                    <p>{(datalogin && datalogin.email) ?? ''}</p>
                                </IonLabel>
                            </IonItem>
                            <IonItem button>
                                <IonAvatar
                                    slot="start"
                                    style={{
                                        '--border-radius': '50%',
                                        border: '1px solid #aaa',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center'
                                    }}>
                                    <IonIcon
                                        color="primary"
                                        icon={constructOutline}
                                        size="small"
                                    />
                                </IonAvatar>
                                <IonLabel>
                                    <h2>Configuración</h2>
                                </IonLabel>
                                <IonAvatar slot="end"
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center'
                                    }}
                                >
                                    <IonIcon
                                        color="primary"
                                        icon={chevronForward}
                                        size="small"
                                    />
                                </IonAvatar>
                            </IonItem>
                            {/* Otros elementos del menú */}
                        </IonList>
                    </IonContent>
                </IonMenu>
            </>
        );
    };
}

const mapStateToProps = (state: any) => {

}

const mapDispatchToProps = (dispatch: any) => {

};

export default connect(mapStateToProps, mapDispatchToProps, null, { forwardRef: true })(MenuPrincipal);

